import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React, { useState, useEffect, forwardRef, useImperativeHandle, } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import SingleHeadingText from "../../CommonTocComponent/TocHeader/SingleHeadingText";
import TocStockHeader from "../../CommonTocComponent/TocHeader/TocStockHeader";
import BuySellBtn from "../../CommonTocComponent/Stock/BuySellBtn";
import BankAccount from "./CommonPaymentMethod/BankAccount";
import NotificationMessage from "../../CommonTocComponent/StatusMessage/NotificationMessage";
import { preffredTop, SebiRulesBottom, SebiRulesTop, } from "../NFOConstant";
import { Col, Row } from "react-bootstrap";
import RadioButton from "@frameworks/web/components/generic/RadioButton/radioButton";
import UnderstandingSectionIcon from "../../CommonTocComponent/UnderstandSection/UnderstandingSectionIcon";
import tocDi from "../../di/servicelocator";
import DiffrentBankAccount from "./BankAccount/DiffrentBankAccount";
import DiffrentUpiId from "./DiffUpiId/DiffrentUpiId";
import WhyUpi from "./CommonPaymentMethod/WhyUpi";
import LoaderEx from "../../MutualFund/CommonComp/LoaderEx";
import { eCollectBankDetails } from "../../constant";
import { useNavigate } from "react-router-dom";
export var EPaymentType;
(function (EPaymentType) {
    EPaymentType["NetBanking"] = "NetBanking";
    EPaymentType["UPI"] = "UPI";
    EPaymentType["ECollect"] = "eCollect";
})(EPaymentType || (EPaymentType = {}));
export const paymentMethodRadio = [
    { value: EPaymentType.NetBanking, display: "Net Banking" },
    { value: EPaymentType.UPI, display: "UPI" },
    // { value: EPaymentType.ECollect, display: "eCollect" },
];
export var EPaymentFlow;
(function (EPaymentFlow) {
    EPaymentFlow["UPI"] = "upi";
    // ADDUPI = "addUPI",
    EPaymentFlow["PAYMENT"] = "payment";
    EPaymentFlow["DIFBANK"] = "difBank";
    EPaymentFlow["DIFUPI"] = "difUPI";
    EPaymentFlow["UPIINFO"] = "upiInfo";
    EPaymentFlow["LOADER"] = "loader";
})(EPaymentFlow || (EPaymentFlow = {}));
const PaymentMethod = forwardRef((props, ref) => {
    const device = DeviceContext();
    const navigate = useNavigate();
    const [paymentMethodData, setpaymentMethodData] = useState(paymentMethodRadio[0].value);
    const [paymentFlow, setPaymentFlow] = useState(EPaymentFlow.PAYMENT);
    const [bankDetails, setBankDetails] = useState();
    const [selectedBank, setSelectedBank] = useState();
    const [bankList, setBankList] = useState();
    const [selectedUPI, setSelectedUPI] = useState();
    const [upiList, setUPIList] = useState();
    useEffect(() => {
        tocDi.payment
            .getPayBankDetails()
            .then((data) => {
            setBankDetails(data.details);
            if (data.details.bnkAcs.length > 0) {
                var bank = data.details.bnkAcs.length > 1
                    ? data.details.bnkAcs.find((x) => x.latest) ||
                        data.details.bnkAcs[0]
                    : data.details.bnkAcs[0];
                setSelectedBank({
                    bnkAcNo: bank.bnkAccNo,
                    bnkNm: bank.bnkName,
                    brn: bank.bankTyp,
                    def: bank.latest,
                    ifscCode: bank.ifsc,
                    bankId: bank.bankid,
                });
                setBankList(data.details.bnkAcs.map((x) => {
                    return {
                        bnkAcNo: x.bnkAccNo,
                        bnkNm: x.bnkName,
                        brn: x.bankTyp,
                        def: x.latest,
                        ifscCode: x.ifsc,
                        bankId: x.bankid,
                    };
                }));
            }
            if (data.details.upis.length > 0) {
                const upilist = data.details.upis.map((x) => {
                    var _a, _b;
                    return Object.assign(Object.assign({}, x), { bankName: (_b = (_a = data.details) === null || _a === void 0 ? void 0 : _a.bnkAcs) === null || _b === void 0 ? void 0 : _b.find((z) => z.bnkAccNo === x.bankaccountnumber).bnkName });
                });
                setUPIList(upilist);
                setSelectedUPI(upilist.find((x) => x.isprimary));
            }
        })
            .catch((error) => console.log(error));
    }, []);
    useImperativeHandle(ref, () => ({
        getSelectedBank: () => selectedBank,
        getSelectedUPI: () => selectedUPI,
        getBankDetails: () => bankDetails,
        getPaymentMethod: () => paymentMethodData,
    }));
    console.log({ paymentMethodData, selectedBank, bankList, upiList }, "paymentPage");
    const PaymentFlowSetup = () => {
        switch (paymentFlow) {
            case EPaymentFlow.LOADER:
                return React.createElement(LoaderEx, null);
            case EPaymentFlow.PAYMENT:
                return (React.createElement(React.Fragment, null,
                    device.isDesktop ? (React.createElement(React.Fragment, null,
                        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Payment" }) }))) : (""),
                    React.createElement("div", { className: "overflow-scroll-400 cust-scroll-bar pb-5 bg_white accountNumber paymentmethodSection" },
                        React.createElement(Col, { lg: 12, className: "outer-body-section" },
                            React.createElement(Col, { lg: 12, className: "mt-3" },
                                React.createElement("h2", { className: "DMSanBold_18_700 txt_blackOne1 " }, "Payment Method"),
                                React.createElement("h4", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Select your preferable payment method"),
                                React.createElement("div", { className: "radio-btn-section" },
                                    React.createElement("div", { className: "outer-payment-radio" }, paymentMethodRadio.map((item) => {
                                        return (React.createElement(RadioButton, { className: "common-radio-button paymentmethodradio", name: "paymentType", list: item, onChange: () => {
                                                setpaymentMethodData(item.value);
                                            }, selected: paymentMethodData }));
                                    })),
                                    React.createElement("div", { className: "radio-rs d-flex" },
                                        React.createElement("div", { className: "recommended-section DMSanM_10_500" }, "Recommended"),
                                        React.createElement("div", { onClick: () => setPaymentFlow(EPaymentFlow.UPIINFO) },
                                            React.createElement(UnderstandingSectionIcon, null)))))),
                        paymentMethodData === EPaymentType.NetBanking && (React.createElement(React.Fragment, null,
                            React.createElement(Col, { lg: 12, className: "mt-1 outer-body-section " },
                                React.createElement("h4", { className: "DMSanM_14_500 txt_primaryGrey mb-10" }, "Select Bank account to pay through Net banking"),
                                React.createElement(BankAccount, { sectionHeadleftTop: "Bank Account Number", sectionHeadleftBottom: selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkAcNo, sectionHeadRightTop: "Bank Name", sectionHeadRightBottom: selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkNm })),
                            (bankList === null || bankList === void 0 ? void 0 : bankList.length) > 1 && (React.createElement(Col, { lg: 12, className: "diffrentbankAccountlink text-center" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80", value: "Choose different bank account", onClick: () => setPaymentFlow(EPaymentFlow.DIFBANK) }))))),
                        paymentMethodData === EPaymentType.UPI && (React.createElement(React.Fragment, null,
                            React.createElement(Col, { lg: 12, className: "mt-1 outer-body-section " },
                                React.createElement("h4", { className: "DMSanM_14_500 txt_primaryGrey mb-10" }, "Select UPI ID to pay through UPI app"),
                                React.createElement("div", { className: "diffrentbankAccountlink text-right" },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80", value: "Add New UPI", onClick: () => navigate("/profile") })),
                                selectedUPI && (React.createElement(BankAccount, { sectionHeadleftTop: "UPI ID", sectionHeadleftBottom: selectedUPI.upi, sectionHeadRightTop: "Bank Name", sectionHeadRightBottom: selectedUPI.bankName }))),
                            (upiList === null || upiList === void 0 ? void 0 : upiList.length) > 1 && (React.createElement(Col, { lg: 12, className: "diffrentbankAccountlink text-center" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80", value: "Choose different UPI ID", onClick: () => setPaymentFlow(EPaymentFlow.DIFUPI) }))))),
                        paymentMethodData === EPaymentType.ECollect && (React.createElement("div", { className: "order-confirmation outer-body-section" },
                            React.createElement(Row, null,
                                React.createElement(Col, { lg: 12, className: "mt-1" },
                                    React.createElement("h4", { className: "DMSanM_14_500 txt_primaryGrey mb-10 " }, "Add our bank account and transfer funds through NEFT or RTGS"))),
                            eCollectBankDetails.map((item) => {
                                return (React.createElement(Row, { className: "orderbody-list m-0" },
                                    React.createElement(Col, { lg: 5, className: "px-0 pb-10 pt-10" },
                                        React.createElement("div", { className: "DMSansNormal_12_400 txt_blackOne1" }, item.key)),
                                    React.createElement(Col, { lg: 7, className: "px-0 pb-10 pt-10" },
                                        React.createElement("div", { className: "DMSans_16_500 txt_blackOne1 text-end" }, item.value))));
                            }))),
                        React.createElement(Col, { lg: 12, className: "notificationsection" },
                            React.createElement(NotificationMessage, { backColor: "#FEF4EC", borderColor: "transparent", notiiconAlert: true, notiHeading: "New Payment Rules by SEBI", DescriptionTop: SebiRulesTop, ShowlinkValue: true, linkValue: "Read more about NAV applicability and fund realization", DescriptionBottom: SebiRulesBottom, showDescriptionBottom: true })),
                        React.createElement(Col, { lg: 12, className: "notificationsection" },
                            React.createElement(NotificationMessage, { borderColor: "#E8E8E8", backColor: "#FFF", prefredIcon: true, notiHeading: "Preferred Banks", DescriptionTop: preffredTop, parentclass: "noti-small-section", linkValue: "Read more about NAV applicability and fund realization", DescriptionBottom: SebiRulesBottom, ShowlinkValue: false, showDescriptionBottom: false }))),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(BuySellBtn, { refreshLabelTitle: "Sell", rightButton: {
                                btnTyp: "midnight-blue",
                                value: `Procced`,
                                className: "w-100",
                                onClick: () => {
                                    if (paymentMethodData === EPaymentType.UPI) {
                                        if ((upiList === null || upiList === void 0 ? void 0 : upiList.length) > 0) {
                                            props.onSubmit();
                                        }
                                    }
                                    else if (paymentMethodData === EPaymentType.NetBanking) {
                                        props.onSubmit();
                                    }
                                },
                            }, cancelAction: () => "" }))));
            case EPaymentFlow.DIFBANK:
                return (React.createElement(DiffrentBankAccount, { back: () => setPaymentFlow(EPaymentFlow.PAYMENT), next: () => setPaymentFlow(EPaymentFlow.PAYMENT), bankList: bankList, setSelectedBank: setSelectedBank, selectedBank: selectedBank }));
            case EPaymentFlow.DIFUPI:
                return (React.createElement(DiffrentUpiId, { back: () => setPaymentFlow(EPaymentFlow.PAYMENT), next: () => setPaymentFlow(EPaymentFlow.PAYMENT), upiList: upiList, selectedUPI: selectedUPI, setSelectedUPI: setSelectedUPI }));
            case EPaymentFlow.UPIINFO:
                return React.createElement(WhyUpi, { back: () => setPaymentFlow(EPaymentFlow.PAYMENT) });
            // case EPaymentFlow.ADDUPI:
            //   return (
            //     <AddNewUpiId
            //       back={() => setPaymentFlow(EPaymentFlow.PAYMENT)}
            //       next={() => setPaymentFlow(EPaymentFlow.UPIAPPROVAL)}
            //       bankList={bankDetails.bnkAcs}
            //     />
            //   );
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PaymentFlowSetup, null)));
});
export default PaymentMethod;
